"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLabelMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.updateLabelMutation = (0, graphql_tag_1.default) `
  mutation UpdateLabel($label: LabelInputType!) {
    updateLabel(label: $label) {
      id
      name
    }
  }
`;
//# sourceMappingURL=update-label.js.map